var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;var self = locals || {};pug_html = pug_html + "\u003Cdiv class=\"Contact\" id=\"contact\"\u003E\u003Cdiv class=\"wrapper\"\u003E\u003Ca class=\"close-popup\" href=\"#\"\u003E\u003C\u002Fa\u003E\u003Ch2 class=\"title\"\u003ELe programme JOÏA vous intéresse?\u003C\u002Fh2\u003E" + (null == (pug_interp = require("./contact-form.pug").call(this, locals)) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/components/contact-popup.pug
// module id = 100
// module chunks = 0